<template>
  <div class="ball-block">
    <component
      class="hori-list"
      v-for="(d, i) in data.horizontal"
      :is="componentName(i)"
      :key="'h' + i"
      :chip="chip"
      :horizontal-type="1"
      :title="d.title"
      :columns="i !== 1 ? 4 : 5"
      :list="d.list"></component>
  </div>
</template>

<script>
  import mixin from '../mixins';
  import GSwitchList1 from '../../c_game-switch/switch-list/g_switch-1'; // 横向
  import GSwitchList3 from '../../c_game-switch/switch-list/g_switch-3'; // 横向
  export default {
    name: "ball",
    mixins: [mixin],
    components: {
      GSwitchList1,
      GSwitchList3
    },
    methods: {
      componentName(index) {
        return index !== 1 ? 'g-switch-list1' : 'g-switch-list3';
      }
    }
  }
</script>

<style scoped lang="stylus">
  .hori-list + .hori-list {
    margin-top 7px
  }
</style>



// WEBPACK FOOTER //
// src/components/pageComponents/gd_ha10/ball.vue